import * as React from 'react';
import { flatMap, uniq, uniqBy } from 'lodash';

import FilterView from '../../views/library/filter.view';
import { IEventFilter, IOption, } from '../../classes/package-listing';
import { IPerformance, IProduction } from '../../custom/classes/production';
import { upsertEventFilter, removeEventFilter, } from '../../redux-state/actions/package-listing.actions';
import { IPackageListingAppState } from '../../redux-state';
import { connect } from 'react-redux';
import { generateEventFilter } from '../../helpers/filter-by-query'
interface IFilterExternalProps {
    /**
     * The property to filter the calendar events by.
     */
    propertyToFilter: keyof IPerformance;
    propertyToDisplay: keyof IPerformance;

    sortFunction: (optionA: IOption, optionB: IOption) => any;
    /**
     * Text to represent the option for no selection. ie All Venues, All Production
     */
    noSelectionText: string;
    /**
     * Name of the filter to be labeled on the app
     */
    filterName: string;
}

interface StateToProps {
    hasFilters: boolean;
    productions: IProduction[];
    selectedValue: string;
}

interface DispatchToProps {
    selectFilter: (selectedValue: string) => void;
}

export type FilterProps = IFilterExternalProps & StateToProps & DispatchToProps;

interface FilterState {
    options: IOption[];
}

export type CombinedFilterViewProps = FilterProps & FilterState;

export class FiltersBase extends React.Component<FilterProps, FilterState> {
    constructor(props: FilterProps) {
        super(props);

        this.state = {
            options: []
        };
    }

    componentDidMount() {
        var currentFilters = this.getFilterOptions(this.props);

        this.setState({
            options: currentFilters
        });
    }
    getFilterOptions(props: FilterProps): Array<IOption> {
        const performances = flatMap(props.productions.map(prod => prod.performances));
        var returnList = [];

        if (performances.length > 0) {
            if (Array.isArray(performances[0][props.propertyToFilter])) {
                return []
            }

            const mappedProperty = uniq(performances.map(performance => {
                return {
                    text: performance[props.propertyToDisplay],
                    value: performance[props.propertyToFilter]
                }
            })).filter(prop => prop != null);

            returnList = uniqBy(mappedProperty.map(eventProperty => {
                return {
                    text: eventProperty.text.toString(),
                    value: eventProperty.value.toString(),
                    firstOccurance: ""
                }
            }), option => option.text);

            if (props.sortFunction == null)
                return returnList;
            return returnList.sort(props.sortFunction);

        }

        return [];
    }

    render() {
        return <FilterView {...this.props} {...this.state} />;
    }
}

function mapStateToProps(state: IPackageListingAppState, ownProps: IFilterExternalProps): StateToProps {
    // Find the matched filter to extract the selected value.
    let matchedFilter: IEventFilter = null;

    for (let i = 0; i < state.packageListing.eventFilter.length; ++i) {
        if (state.packageListing.eventFilter[i].key === ownProps.propertyToFilter) {
            matchedFilter = state.packageListing.eventFilter[i];
            break;
        }
    }

    return {
        hasFilters: state.packageListing.eventFilter.length > 0,
        productions: flatMap(state.packageListing.packageDetail.performanceGroupDetails.map(g => g.appProductions)),
        selectedValue: matchedFilter ? matchedFilter.selectedValue : ""
    }
}

function mapDispatchToProps(dispatch, ownProps: FilterProps): DispatchToProps {
    return {
        selectFilter: (selectedValue: string) => {
            // If the selected value is null or empty string, remove that filter.
            if (!selectedValue || selectedValue === "") {
                dispatch(removeEventFilter(ownProps.propertyToFilter));
            } else {

                const filter: IEventFilter = {
                    key: ownProps.propertyToFilter,
                    selectedValue: selectedValue,
                    filter: generateEventFilter(ownProps.propertyToFilter, selectedValue)
                }
                dispatch(upsertEventFilter(filter));
            }
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(FiltersBase);